import useNotificationsOptOut from 'lib/hooks/useNotificationsOptOut';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAndRefreshSharedUiData } from 'store/consumerPreferences/actions';
import {
  hasSeenNotificationOptOutSelector,
  consumerUiDataIsFetchingSelector
} from 'store/consumerPreferences/selectors';
import { ConsumerSharedUiData } from 'store/consumerPreferences/types';
import analyticsService, { AMPLITUDE_EXPERIMENTS } from 'services/AnalyticsService';

const useNotificationsOptOutTrigger = () => {
  const [hasTriggered, setHasTriggered] = useState<boolean>(false);
  const consumerUiDataIsFetching = useSelector(consumerUiDataIsFetchingSelector);
  const hasSeenNotificationOptOut = useSelector(hasSeenNotificationOptOutSelector);
  const dispatch = useDispatch();

  const [showPromptFlag, setShowPromptFlag] = useState(false);
  useEffect(() => {
    const notificationOptOutActive = analyticsService.getExperimentStatus(
      AMPLITUDE_EXPERIMENTS.NOTIFICATIONS_OPT_OUT_ALERT.flagKey,
      AMPLITUDE_EXPERIMENTS.NOTIFICATIONS_OPT_OUT_ALERT.variantA
    );

    setShowPromptFlag(notificationOptOutActive);
  }, []);

  const { doSmsEnroll, hasInitialized, isEmailEnabled } = useNotificationsOptOut(showPromptFlag);

  useEffect(() => {
    if (showPromptFlag && hasInitialized && !hasSeenNotificationOptOut) {
      const params: Partial<ConsumerSharedUiData> = {
        hasSeenNotificationOptOut: true
      };
      dispatch(updateAndRefreshSharedUiData(params));
    }
  }, [showPromptFlag, hasInitialized]);

  let doTrigger = false;

  if (hasInitialized) {
    doTrigger = !!(!isEmailEnabled || doSmsEnroll);
  }

  if (!consumerUiDataIsFetching && doTrigger && !hasSeenNotificationOptOut && !hasTriggered) {
    setHasTriggered(true);
  }

  return hasTriggered;
};

export default useNotificationsOptOutTrigger;
